import { proxy } from 'valtio';
import { InstrumentService } from './instrument.service';
export const instrumentService = proxy(new InstrumentService());
